<template>
    <md-card class="md-card-chart">
        <md-card-header :data-header-animation="headerAnimation"
                        :class="[
        { animated: true },
        { [getClass(backgroundColor)]: true },
        { 'md-card-header-text': HeaderText },
        { 'md-card-header-icon': HeaderIcon }
      ]">
            <div v-if="chartInsideHeader" class="chart-js-chart"></div>
            <slot name="chartInsideHeader"></slot>
        </md-card-header>

        <md-card-content>
            <div v-if="chartInsideContent" class="chart-js-chart"></div>
            <slot name="content"></slot>
        </md-card-content>

        <md-card-actions md-alignment="left" v-if="!noFooter">
            <slot name="footer"></slot>
        </md-card-actions>
    </md-card>
</template>
<script>
    export default {
        name: "ChartJsCard",
        props: {
            HeaderText: Boolean,
            HeaderIcon: Boolean,
            noFooter: Boolean,
            chartInsideContent: Boolean,
            chartInsideHeader: Boolean,
            headerAnimation: {
                type: String,
                default: "true"
            },
            backgroundColor: {
                type: String,
                default: ""
            }
        },
        methods: {
            getClass: function (backgroundColor) {
                return "md-card-header-" + backgroundColor + "";
            }
        },
        mounted() {

        }
    };
</script>
